import React from 'react';

interface PageHeaderProps {
  text: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ text }) => {
  return <h1 className='text-coffee text-6xl font-bold font-raleway mt-28 ml-10'>{text}</h1>;
};

export default PageHeader;
